<template>
  <data-sync-panel title="捷卫士数据同步" source="捷卫士" :use-jws-api="true" />
</template>

<script>
import DataSyncPanel from '../components/DataSyncPanel'
export default {
  name: 'CheliangJwsSyncCaiwu',
  components: { DataSyncPanel }
}
</script>
